<template>
  <div style="height: 100%; overflow-y: auto; padding: 0 4px;">
    <!-- ================= 铺货档位配置 ================= -->
    <div class="zone">
      <div class="zone-header">
        <span class="zone-bar"></span>
        <span class="zone-title">铺货档位配置</span>
        <span class="zone-desc">如3000/5000元档 · 冻结时快照档位名称/金额,档位改价不影响存量冻结 · 停用档位不可再选</span>
      </div>
      <el-row class="filter-bar" ref="filterBar" style="padding: 0 0 10px;">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="tierOpenAdd">新增档位</el-button>
      </el-row>
      <div class="tablecss" v-loading="tierTableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="tiervetable" :columns="tierColumns" :table-data="tierTableData" :max-height="220"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="tierTableData.length == 0" class="empty-data">暂无档位,请先新增</div>
        </div>
      </div>
    </div>

    <!-- ================= 冻结记录 ================= -->
    <div class="zone">
      <div class="zone-header">
        <span class="zone-bar"></span>
        <span class="zone-title">冻结记录</span>
        <span class="zone-desc">可提现余额 = 账户余额 − 冻结金额 · 冻结可超过余额(可提现为0,超出部分随收入增长可提) · 解冻按件数释放差额</span>
      </div>
      <el-row class="filter-bar" ref="filterBar" style="padding: 6px 0 10px;">
        <el-input v-model="fzForm.asName" style="width: 200px;" size="mini" placeholder="商户名称搜索" clearable
          @keyup.enter.native="fzSearch" @clear="fzSearch"></el-input>
        <el-select v-model="fzForm.aasfStatus" size="mini" placeholder="状态" clearable style="width: 110px; margin: 0 8px;"
          @change="fzSearch">
          <el-option label="冻结中" :value="1"></el-option>
          <el-option label="已解冻" :value="2"></el-option>
        </el-select>
        <el-button type="info" size="mini" icon="el-icon-search" @click="fzSearch">搜索</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="fzOpenAdd">新增冻结</el-button>
      </el-row>
      <div class="tablecss" v-loading="fzTableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="fzvetable" :columns="fzColumns" :table-data="fzTableData" :max-height="fzTableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            style="width: 100%" />
          <div v-show="fzTableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="fzTotalCount" :page-index="fzPage.currentPage" :page-size="fzPage.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="fzPageNumberChange"
            @on-page-size-change="fzPageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 档位新增/编辑弹窗 -->
    <el-dialog :title="tierDialog.aastId ? '编辑档位' : '新增档位'" :visible.sync="tierDialogVisible"
      width="420px" :close-on-click-modal="false" top="18vh">
      <el-form label-width="80px" size="mini" label-position="right">
        <el-form-item label="档位名称" required>
          <el-input v-model="tierDialog.aastName" placeholder="如 3000元档" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="档位金额" required>
          <el-input v-model="tierDialog.aastAmountYuan" placeholder="单位元,如 3000" style="width: 100%"
            @input="e => tierDialog.aastAmountYuan = e.replace(/[^\d.]/g, '')">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="tierDialog.aastOrder" :min="0" :max="9999" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="tierDialog.aastStatus">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="tierDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" :loading="tierSaving" @click="tierSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 新增冻结弹窗 -->
    <el-dialog title="新增冻结" :visible.sync="fzDialogVisible" width="560px" :close-on-click-modal="false" top="12vh">
      <el-form label-width="80px" size="mini" label-position="right">
        <el-form-item label="商户" required>
          <el-select v-model="fzDialog.asId" filterable placeholder="输入名称/ID搜索选择商户" style="width: 100%"
            @change="fzLoadAccount">
            <el-option v-for="item in shopOptions" :key="item.asId" :label="item.asId + ' - ' + item.asName"
              :value="item.asId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="fzAccount" class="account-line">
        账户余额 <b>{{ fzAccount.asaBalanceYuan }}</b> 元 · 已冻结 <b class="money-strong">{{ fzAccount.frozenTotalYuan }}</b> 元 ·
        可提现 <b>{{ fzAccount.asaAvailableYuan }}</b> 元
      </div>
      <div class="item-rows">
        <div v-for="(row, index) in fzDialog.items" :key="index" class="item-row">
          <el-select v-model="row.aastId" placeholder="选择档位" size="mini" style="width: 200px;" @change="fzTotalMoney">
            <el-option v-for="t in enabledTiers" :key="t.aastId"
              :label="t.aastName + '(' + fenToYuan(t.aastAmount) + '元)'" :value="t.aastId"></el-option>
          </el-select>
          <span class="item-x">×</span>
          <el-input-number v-model="row.aasfCount" :min="1" :max="9999" size="mini" style="width: 110px;"
            @change="fzTotalMoney"></el-input-number>
          <span class="item-x">件</span>
          <el-button type="text" size="mini" style="color: #F56C6C; margin-left: 8px;"
            :disabled="fzDialog.items.length <= 1" @click="fzRemoveRow(index)">删除</el-button>
        </div>
        <el-button type="text" size="mini" icon="el-icon-plus" @click="fzAddRow">加一行档位</el-button>
      </div>
      <div class="fz-total">本次冻结合计:<b class="money-strong">{{ fzTotalYuan }}</b> 元<span
          v-if="fzAccount && fzTotalFen > 0"> · 冻结后可提现
          <b>{{ fenToYuan(Math.max(fenFromYuan(fzAccount.asaBalanceYuan) - fenFromYuan(fzAccount.frozenTotalYuan) - fzTotalFen, 0)) }}</b> 元(可为0,不要求余额足够)</span></div>
      <el-form label-width="80px" size="mini" label-position="right" style="margin-top: 6px;">
        <el-form-item label="备注">
          <el-input v-model="fzDialog.aasfDes" placeholder="选填,如 第一次铺货" style="width: 100%" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="fzDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" :loading="fzSaving" @click="fzSave">确认冻结</el-button>
      </div>
    </el-dialog>

    <!-- 解冻弹窗 -->
    <el-dialog title="解冻" :visible.sync="ufDialogVisible" width="440px" :close-on-click-modal="false" top="18vh">
      <div class="uf-info" v-if="ufRow">
        {{ ufRow.asName || ('商户' + ufRow.asId) }} · {{ ufRow.aasfTierName }}({{ ufRow.aasfTierAmountYuan }}元/件) ·
        剩余<b>{{ ufRow.aasfCount }}</b>件 / <b class="money-strong">{{ ufRow.aasfMoneyYuan }}</b>元
      </div>
      <el-form label-width="80px" size="mini" label-position="right" style="margin-top: 10px;">
        <el-form-item label="解冻方式">
          <el-radio-group v-model="ufAll">
            <el-radio :label="false">按件数</el-radio>
            <el-radio :label="true">全部解冻</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="解冻件数" v-if="!ufAll">
          <el-input-number v-model="ufCount" :min="1" :max="ufRow ? ufRow.aasfCount : 1" size="mini"
            style="width: 140px;"></el-input-number>
          <span class="uf-preview">解冻金额:<b class="money-strong">{{ ufPreviewYuan }}</b> 元</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ufDes" placeholder="选填,如 已售回款" style="width: 100%" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="ufDialogVisible = false">取 消</el-button>
        <el-button type="danger" size="mini" :loading="ufSaving" @click="ufSave">确认解冻</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import { getAjefAgentStockTierList, updateAjefAgentStockTier, deleteAjefAgentStockTier,
  getAjefAgentStockFreezeList, getAjefAgentStockShopAccount, addAjefAgentStockFreeze,
  unfreezeAjefAgentStockFreeze, getAjefShopListQuick } from "../../api/api";
export default {
  name: "AgentStockFreeze",
  components: {},
  data() {
    return {
      watchFlag: false,
      windheight: 0,
      // ===== 档位配置 =====
      tierTableLoading: false,
      tierTableData: [],
      tierDialogVisible: false,
      tierSaving: false,
      tierDialog: { aastId: null, aastName: "", aastAmountYuan: "", aastOrder: 0, aastStatus: 1 },
      tierColumns: [
        {
          field: "", key: "a", title: "序号", width: 60, align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => { return ++rowIndex; },
        },
        { field: "aastName", key: "aastName", title: "档位名称", width: 180, align: "center" },
        {
          field: "aastAmountYuan", key: "aastAmountYuan", title: "档位金额", width: 140, align: "center",
          renderBodyCell: ({ row }, h) => { return h('span', { class: 'money-strong' }, row.aastAmountYuan + '元'); },
        },
        { field: "aastOrder", key: "aastOrder", title: "排序", width: 80, align: "center" },
        {
          field: "aastStatus", key: "aastStatus", title: "状态", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.aastStatus == 1
              ? h('el-tag', { props: { size: "mini", type: "success" } }, '启用')
              : h('el-tag', { props: { size: "mini", type: "info" } }, '停用');
          },
        },
        { field: "createusername", key: "createusername", title: "创建人", width: 90, align: "center" },
        { field: "updatetime", key: "updatetime", title: "更新时间", width: 155, align: "center" },
        {
          field: "", key: "operation", title: "操作", align: "center", width: 190, fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return h('div', [
              h('el-button', { props: { type: 'text', size: 'mini' }, on: { click: () => this.tierOpenEdit(row) } }, '编辑'),
              h('el-button', {
                props: { type: 'text', size: 'mini' },
                on: { click: () => this.tierToggleStatus(row) }
              }, row.aastStatus == 1 ? '停用' : '启用'),
              h('el-button', {
                props: { type: 'text', size: 'mini' }, style: { color: '#F56C6C' },
                on: { click: () => this.tierDelete(row) }
              }, '删除')
            ]);
          },
        },
      ],
      // ===== 冻结记录 =====
      fzTableLoading: false,
      fzTableData: [],
      fzTotalCount: 0,
      fzTableHight: 320,
      fzForm: { asName: "", aasfStatus: null },
      fzPage: { currentPage: 1, pageSize: 20 },
      fzDialogVisible: false,
      fzSaving: false,
      fzDialog: { asId: null, items: [{ aastId: null, aasfCount: 1 }], aasfDes: "" },
      fzAccount: null,
      fzTotalFen: 0,
      shopOptions: [],
      // 解冻
      ufDialogVisible: false,
      ufSaving: false,
      ufRow: null,
      ufAll: false,
      ufCount: 1,
      ufDes: "",
      fzColumns: [
        {
          field: "", key: "a", title: "序号", width: 60, align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (this.fzPage.currentPage - 1) * this.fzPage.pageSize + rowIndex + 1;
          },
        },
        { field: "aasfBatch", key: "aasfBatch", title: "批次", width: 150, align: "center" },
        { field: "asId", key: "asId", title: "商户ID", width: 80, align: "center" },
        {
          field: "asName", key: "asName", title: "商户名称", align: "left",
          renderBodyCell: ({ row }) => { return row.asName || "-"; },
        },
        {
          field: "aasfTierName", key: "aasfTierName", title: "档位", width: 150, align: "center",
          renderBodyCell: ({ row }, h) => {
            return h('span', {}, row.aasfTierName + '(' + row.aasfTierAmountYuan + '元/件)');
          },
        },
        {
          field: "aasfCount", key: "aasfCount", title: "件数(剩余/初始)", width: 120, align: "center",
          renderBodyCell: ({ row }) => { return row.aasfCount + " / " + row.aasfCountInit; },
        },
        {
          field: "aasfMoneyYuan", key: "aasfMoneyYuan", title: "冻结额(剩余/初始)", width: 140, align: "center",
          renderBodyCell: ({ row }, h) => {
            return h('span', { class: row.aasfStatus == 1 ? 'money-strong' : 'money-muted' },
              row.aasfMoneyYuan + " / " + row.aasfMoneyInitYuan);
          },
        },
        {
          field: "aasfStatus", key: "aasfStatus", title: "状态", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.aasfStatus == 1
              ? h('el-tag', { props: { size: "mini", type: "danger" } }, '冻结中')
              : h('el-tag', { props: { size: "mini", type: "info" } }, '已解冻');
          },
        },
        { field: "createusername", key: "createusername", title: "冻结人", width: 90, align: "center" },
        { field: "createtime", key: "createtime", title: "冻结时间", width: 155, align: "center" },
        { field: "aasfUnfreezeUsername", key: "aasfUnfreezeUsername", title: "解冻人", width: 90, align: "center" },
        { field: "aasfUnfreezetime", key: "aasfUnfreezetime", title: "解冻时间", width: 155, align: "center" },
        {
          field: "aasfDes", key: "aasfDes", title: "备注", align: "left",
          renderBodyCell: ({ row }) => { return row.aasfDes || "-"; },
        },
        {
          field: "", key: "operation", title: "操作", align: "center", width: 90, fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            if (row.aasfStatus != 1) {
              return "-";
            }
            return h('el-button', {
              props: { type: 'text', size: 'mini' }, style: { color: '#E6A23C' },
              on: { click: () => this.ufOpen(row) }
            }, '解冻');
          },
        },
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
    };
  },
  computed: {
    enabledTiers() {
      return this.tierTableData.filter((t) => t.aastStatus == 1);
    },
    fzTotalYuan() {
      return this.fenToYuan(this.fzTotalFen);
    },
    ufPreviewYuan() {
      if (!this.ufRow) {
        return "0.00";
      }
      const count = this.ufAll ? this.ufRow.aasfCount : this.ufCount;
      return ((this.ufRow.aasfTierAmount * count) / 100).toFixed(2);
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.calcHeights();
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.calcHeights(val);
        }
      });
    },
  },
  mounted() {
    this.tierGetList();
    this.fzGetList();
    this.loadShops();
  },
  methods: {
    calcHeights(val) {
      //档位区约300px,冻结记录表占剩余
      const full = calcTableHeight(this, val || this.windheight, 140);
      this.fzTableHight = Math.max(full - 350, 200);
    },
    fenToYuan(fen) {
      return ((fen || 0) / 100).toFixed(2);
    },
    fenFromYuan(yuan) {
      return Math.round(parseFloat(yuan || 0) * 100);
    },
    // ===== 档位配置 =====
    tierGetList() {
      this.tierTableLoading = true;
      getAjefAgentStockTierList({}).then((res) => {
        this.tierTableLoading = false;
        this.tierTableData = res.data || [];
      }).catch(() => {
        this.tierTableLoading = false;
      });
    },
    tierOpenAdd() {
      this.tierDialog = { aastId: null, aastName: "", aastAmountYuan: "", aastOrder: 0, aastStatus: 1 };
      this.tierDialogVisible = true;
    },
    tierOpenEdit(row) {
      this.tierDialog = {
        aastId: row.aastId,
        aastName: row.aastName,
        aastAmountYuan: row.aastAmountYuan,
        aastOrder: row.aastOrder,
        aastStatus: row.aastStatus,
      };
      this.tierDialogVisible = true;
    },
    tierToggleStatus(row) {
      const action = row.aastStatus == 1 ? "停用" : "启用";
      updateAjefAgentStockTier({
        aastId: row.aastId, aastName: row.aastName, aastAmountYuan: row.aastAmountYuan,
        aastOrder: row.aastOrder, aastStatus: row.aastStatus == 1 ? 2 : 1,
      }).then(() => {
        this.$message.success("已" + action);
        this.tierGetList();
      });
    },
    tierDelete(row) {
      this.$confirm('删除档位「' + row.aastName + '」?有冻结中记录引用时会拒绝;存量已解冻记录存有快照不受影响。', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAjefAgentStockTier({ aastId: row.aastId }).then(() => {
          this.$message.success("已删除");
          this.tierGetList();
        });
      }).catch(() => { });
    },
    tierSave() {
      if (!this.tierDialog.aastName) {
        this.$message.warning("请输入档位名称");
        return;
      }
      if (!this.tierDialog.aastAmountYuan || parseFloat(this.tierDialog.aastAmountYuan) <= 0) {
        this.$message.warning("请填写大于0的档位金额");
        return;
      }
      this.tierSaving = true;
      updateAjefAgentStockTier(this.tierDialog).then(() => {
        this.tierSaving = false;
        this.$message.success("保存成功");
        this.tierDialogVisible = false;
        this.tierGetList();
      }).catch(() => {
        this.tierSaving = false;
      });
    },
    // ===== 冻结记录 =====
    loadShops() {
      if (this.shopOptions.length === 0) {
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
          this.shopOptions = res.data || [];
        });
      }
    },
    fzGetList() {
      this.fzTableLoading = true;
      const params = Object.assign({}, this.fzPage, {
        asName: this.fzForm.asName || null,
        aasfStatus: this.fzForm.aasfStatus || null,
      });
      getAjefAgentStockFreezeList(params).then((res) => {
        this.fzTableLoading = false;
        this.fzTableData = res.data || [];
        this.fzTotalCount = res.total || 0;
      }).catch(() => {
        this.fzTableLoading = false;
      });
    },
    fzSearch() {
      this.fzPage.currentPage = 1;
      this.fzGetList();
    },
    fzPageNumberChange(pageIndex) {
      this.fzPage.currentPage = pageIndex;
      this.fzGetList();
    },
    fzPageSizeChange(pageSize) {
      this.fzPage.pageSize = pageSize;
      this.fzGetList();
    },
    fzOpenAdd() {
      this.loadShops();
      this.fzDialog = { asId: null, items: [{ aastId: null, aasfCount: 1 }], aasfDes: "" };
      this.fzAccount = null;
      this.fzTotalFen = 0;
      this.fzDialogVisible = true;
    },
    fzLoadAccount(asId) {
      if (!asId) {
        this.fzAccount = null;
        return;
      }
      getAjefAgentStockShopAccount({ asId: asId }).then((res) => {
        this.fzAccount = res.data;
      });
    },
    fzAddRow() {
      this.fzDialog.items.push({ aastId: null, aasfCount: 1 });
    },
    fzRemoveRow(index) {
      this.fzDialog.items.splice(index, 1);
      this.fzTotalMoney();
    },
    fzTotalMoney() {
      let total = 0;
      for (const row of this.fzDialog.items) {
        const tier = this.tierTableData.find((t) => t.aastId == row.aastId);
        if (tier && row.aasfCount > 0) {
          total += tier.aastAmount * row.aasfCount;
        }
      }
      this.fzTotalFen = total;
    },
    fzSave() {
      if (!this.fzDialog.asId) {
        this.$message.warning("请选择商户");
        return;
      }
      const items = this.fzDialog.items.filter((row) => row.aastId && row.aasfCount > 0);
      if (items.length === 0) {
        this.$message.warning("请至少选择一个档位并填写数量");
        return;
      }
      this.$confirm('确认为该商户冻结 ' + this.fzTotalYuan + ' 元?冻结后可提现余额=账户余额-冻结金额(可为0)。', '确认冻结', {
        confirmButtonText: '确认冻结',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.fzSaving = true;
        addAjefAgentStockFreeze({
          asId: this.fzDialog.asId,
          items: JSON.stringify(items),
          aasfDes: this.fzDialog.aasfDes || null,
        }).then((res) => {
          this.fzSaving = false;
          this.$message.success((res.data && res.data.message) || "已冻结");
          this.fzDialogVisible = false;
          this.fzGetList();
        }).catch(() => {
          this.fzSaving = false;
        });
      }).catch(() => { });
    },
    // ===== 解冻 =====
    ufOpen(row) {
      this.ufRow = row;
      this.ufAll = false;
      this.ufCount = 1;
      this.ufDes = "";
      this.ufDialogVisible = true;
    },
    ufSave() {
      if (!this.ufAll && (!this.ufCount || this.ufCount < 1)) {
        this.$message.warning("请填写解冻件数");
        return;
      }
      if (!this.ufAll && this.ufRow && this.ufCount > this.ufRow.aasfCount) {
        this.$message.warning("解冻件数不能超过剩余件数");
        return;
      }
      this.ufSaving = true;
      unfreezeAjefAgentStockFreeze({
        aasfId: this.ufRow.aasfId,
        count: this.ufAll ? 0 : this.ufCount,
        aasfDes: this.ufDes || null,
      }).then((res) => {
        this.ufSaving = false;
        this.$message.success((res.data && res.data.message) || "已解冻");
        this.ufDialogVisible = false;
        this.fzGetList();
      }).catch(() => {
        this.ufSaving = false;
      });
    },
  },
};
</script>

<style scoped>
.zone {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 12px 12px;
  margin-bottom: 14px;
}

.zone-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f2f5;
  margin-bottom: 10px;
}

.zone-bar {
  display: inline-block;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: #409eff;
  margin-right: 8px;
}

.zone-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin-right: 12px;
  white-space: nowrap;
}

.zone-desc {
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-line {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
  margin: 0 0 10px;
}

.item-rows {
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  padding: 10px 12px 6px;
}

.item-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.item-x {
  margin: 0 8px;
  color: #606266;
  font-size: 13px;
}

.fz-total {
  margin-top: 10px;
  font-size: 13px;
  color: #303133;
}

.dialog-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}

.uf-info {
  background: #fdf6ec;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 12px;
  color: #606266;
}

.uf-preview {
  margin-left: 14px;
  font-size: 12px;
  color: #606266;
}
</style>

<style>
/* ve-table单元格内通用强调样式(非scoped,renderBodyCell的h()不经过scoped编译) */
.money-strong {
  font-weight: bold;
  color: #f56c6c;
}

.money-muted {
  color: #909399;
}
</style>
